import { DEACTIVATED_USERS_LIST_TAG } from '../constants';
import { api } from '../core';

export type UserReactivateResponse = null;

export type UserReactivateProps = {
  userToEditId: string;
};

const userReactivateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postUserReactivate: builder.query<UserReactivateResponse, UserReactivateProps>({
      query: ({ userToEditId }: UserReactivateProps) => ({
        url: 'user/reactivate',
        method: 'POST',
        body: {
          userToEditId: userToEditId
        }
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(api.util.invalidateTags([DEACTIVATED_USERS_LIST_TAG]));
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postUserReactivate in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostUserReactivateQuery } = userReactivateApi;
